import { mockReferralDB } from './mockDb';
import type { Staff, StaffFormData } from '../types';

export const staffService = {
  async getAll(): Promise<Staff[]> {
    await new Promise(resolve => setTimeout(resolve, 100));
    return mockReferralDB.getStaff();
  },

  async getById(id: string): Promise<Staff> {
    await new Promise(resolve => setTimeout(resolve, 100));
    const staff = mockReferralDB.getStaffMember(id);
    if (!staff) throw new Error('Staff member not found');
    return staff;
  },

  async getByCode(code: string): Promise<Staff | null> {
    await new Promise(resolve => setTimeout(resolve, 100));
    return mockReferralDB.getStaffByCode(code) || null;
  },

  async create(data: StaffFormData): Promise<Staff> {
    await new Promise(resolve => setTimeout(resolve, 200));
    return mockReferralDB.createStaff(data);
  },

  async update(id: string, data: Partial<StaffFormData>): Promise<Staff> {
    await new Promise(resolve => setTimeout(resolve, 200));
    const updated = mockReferralDB.updateStaff(id, data);
    if (!updated) throw new Error('Staff member not found');
    return updated;
  },

  async delete(id: string): Promise<void> {
    await new Promise(resolve => setTimeout(resolve, 200));
    const updated = mockReferralDB.updateStaff(id, { active: false });
    if (!updated) throw new Error('Staff member not found');
  },
};
